import { ChangeDetectionStrategy, Component, effect, HostBinding, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RoleModel } from '../../../../models/role.model';
import { OptionalType } from '../../../../models/types/optional.type';
import { RolesResource } from '../../../../services/resources/roles.resource';

@Component({
    selector: 'sl-layout-default-settings',
    templateUrl: './layout-default-settings.component.html',
    styleUrls: ['./layout-default-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LayoutDefaultSettingsComponent implements OnInit {
    @HostBinding('class') classes = 'overflow-hidden d-flex flex-column';

    readonly roles = signal<RoleModel[]>([]);
    readonly selectedRoleId = signal<OptionalType<number>>(undefined);

    private readonly rolesResource = inject(RolesResource);
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    constructor() {
        effect(() => {
            const selectedRoleId = this.selectedRoleId();
            if (!!selectedRoleId) {
                this.router.navigate([], {
                    queryParams: { id: selectedRoleId },
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                });
            }
        });
    }

    ngOnInit(): void {
        this.rolesResource.getAll().subscribe(resp => {
            const roles = resp.value.filter(r => +r.id !== 0);
            this.roles.set(roles);

            // Set the selectedRoleId based on the URL query parameter if present
            const roleIdFromUrl = Number(this.activatedRoute.snapshot.queryParamMap.get('id'));
            if (!!roleIdFromUrl && roles.some(r => r.id === roleIdFromUrl)) {
                this.selectedRoleId.set(+roleIdFromUrl);
            }
        });
    }
}
